import { render } from "./EditBuildingForm.vue?vue&type=template&id=2c84573c"
import script from "./EditBuildingForm.vue?vue&type=script&lang=js"
export * from "./EditBuildingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__